module.exports = __webpack_public_path__ + "img/map.a898ad8c.png";